// src/lib/sentry.ts
import * as Sentry from "@sentry/react";

const isDev = process.env.NODE_ENV === "development";

let initialized = false;

export function initSentry() {
  if (initialized) return;

  const dsn = process.env.NEXT_PUBLIC_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: isDev ? 1.0 : 0.1,
    replaysSessionSampleRate: isDev ? 1.0 : 0.1,
    replaysOnErrorSampleRate: 1.0,
  });

  initialized = true;
}
